import { createSlice } from '@reduxjs/toolkit';

import { getGlobalParam } from '@agilemd/ui-utils';

import reexportSelector from '../utils/reexportSelector.js';

const initialState = {
  practitionerSpecialties: getGlobalParam('practitionerSpecialties', [])
};
const reexport = reexportSelector('ui');

export const uiSlice = /** @type {import('@reduxjs/toolkit').Slice} */ (
  createSlice({
    name: 'ui',
    initialState,
    reducers: {
      setSpecialties: (s, { payload: practitionerSpecialties }) => {
        s.practitionerSpecialties = practitionerSpecialties;
      }
    }
  })
);

export const { setSpecialties } = uiSlice.actions;

export const getPractitionerSpecialties = reexport(state => state.practitionerSpecialties);

export default uiSlice.reducer;
